import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { types, getSnapshot } from 'mobx-state-tree';
import { getConf, readConfObject } from '@jbrowse/core/configuration';
import { dedupe, getSession, getEnv } from '@jbrowse/core/util';
import { getTrackName } from '@jbrowse/core/util/tracks';
import { ElementId } from '@jbrowse/core/util/types/mst';
function hasAnyOverlap() {
  var a1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var a2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return !!a1.find(function (value) {
    return a2.includes(value);
  });
}
export function matches(query, conf, session) {
  var categories = readConfObject(conf, 'category');
  var queryLower = query.toLowerCase();
  return getTrackName(conf, session).toLowerCase().includes(queryLower) || !!(categories === null || categories === void 0 ? void 0 : categories.filter(function (c) {
    return c.toLowerCase().includes(queryLower);
  }).length);
}
function filterTracks(tracks, self, assemblyName) {
  var _getSession = getSession(self),
    assemblyManager = _getSession.assemblyManager;
  var _getEnv = getEnv(self),
    pluginManager = _getEnv.pluginManager;
  var assembly = assemblyManager.get(assemblyName);
  if (!assembly) {
    return [];
  }
  var allAliases = assembly.allAliases;
  return tracks.filter(function (c) {
    return hasAnyOverlap(allAliases, readConfObject(c, 'assemblyNames'));
  }).filter(function (c) {
    var _pluginManager$getVie = pluginManager.getViewType(self.view.type),
      displayTypes = _pluginManager$getVie.displayTypes;
    var compatDisplays = displayTypes.map(function (d) {
      return d.name;
    });
    var trackDisplays = c.displays.map(function (d) {
      return d.type;
    });
    return hasAnyOverlap(compatDisplays, trackDisplays);
  });
}
export function generateHierarchy(model, trackConfigurations, collapsed, extra) {
  var hierarchy = {
    children: []
  };
  var filterText = model.filterText,
    view = model.view;
  var session = getSession(model);
  trackConfigurations.filter(function (conf) {
    return matches(filterText, conf, session);
  }).forEach(function (conf) {
    // copy the categories since this array can be mutated downstream
    var categories = _toConsumableArray(readConfObject(conf, 'category') || []);
    // silly thing where if trackId ends with sessionTrack, then push it to
    // a category that starts with a space to force sort to the top...
    // double whammy hackyness
    if (conf.trackId.endsWith('sessionTrack')) {
      categories.unshift(' Session tracks');
    }
    var currLevel = hierarchy;
    // find existing category to put track into or create it
    var _loop = function _loop() {
      var category = categories[i];
      var ret = currLevel.children.find(function (c) {
        return c.name === category;
      });
      var id = extra + '-' + categories.slice(0, i + 1).join(',');
      if (!ret) {
        var n = {
          children: [],
          name: category,
          id: id,
          isOpenByDefault: !collapsed.get(id)
        };
        currLevel.children.push(n);
        currLevel = n;
      } else {
        currLevel = ret;
      }
    };
    for (var i = 0; i < categories.length; i++) {
      _loop();
    }
    var tracks = view.tracks;
    // using splice here tries to group leaf nodes above hierarchical nodes
    currLevel.children.splice(currLevel.children.findIndex(function (elt) {
      return elt.children.length;
    }), 0, {
      id: conf.trackId,
      name: getTrackName(conf, session),
      conf: conf,
      checked: !!tracks.find(function (f) {
        return f.configuration === conf;
      }),
      children: []
    });
  });
  return hierarchy.children;
}
export default function stateTreeFactory(pluginManager) {
  return types.model('HierarchicalTrackSelectorWidget', {
    id: ElementId,
    type: types.literal('HierarchicalTrackSelectorWidget'),
    collapsed: types.map(types.boolean),
    view: types.safeReference(pluginManager.pluggableMstType('view', 'stateModel'))
  }).volatile(function () {
    return {
      selection: [],
      filterText: ''
    };
  }).actions(function (self) {
    return {
      setSelection: function setSelection(elt) {
        self.selection = elt;
      },
      addToSelection: function addToSelection(elt) {
        self.selection = dedupe([].concat(_toConsumableArray(self.selection), _toConsumableArray(elt)), function (e) {
          return e.trackId;
        });
      },
      removeFromSelection: function removeFromSelection(elt) {
        self.selection = self.selection.filter(function (f) {
          return !elt.includes(f);
        });
      },
      clearSelection: function clearSelection() {
        self.selection = [];
      },
      setView: function setView(view) {
        self.view = view;
      },
      toggleCategory: function toggleCategory(pathName) {
        self.collapsed.set(pathName, !self.collapsed.get(pathName));
      },
      clearFilterText: function clearFilterText() {
        self.filterText = '';
      },
      setFilterText: function setFilterText(newText) {
        self.filterText = newText;
      }
    };
  }).views(function (self) {
    return {
      getRefSeqTrackConf: function getRefSeqTrackConf(assemblyName) {
        var _getSession2 = getSession(self),
          assemblyManager = _getSession2.assemblyManager;
        var assembly = assemblyManager.get(assemblyName);
        var trackConf = assembly === null || assembly === void 0 ? void 0 : assembly.configuration.sequence;
        var viewType = pluginManager.getViewType(self.view.type);
        if (!trackConf) {
          return undefined;
        }
        var _iterator = _createForOfIteratorHelper(trackConf.displays),
          _step;
        try {
          var _loop2 = function _loop2() {
            var display = _step.value;
            if (viewType.displayTypes.find(function (d) {
              return d.name === display.type;
            })) {
              return {
                v: trackConf
              };
            }
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _ret = _loop2();
            if (typeof _ret === "object") return _ret.v;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    };
  }).views(function (self) {
    return {
      trackConfigurations: function trackConfigurations(assemblyName) {
        if (!self.view) {
          return [];
        }
        var _getSession3 = getSession(self),
          tracks = _getSession3.tracks,
          assemblyManager = _getSession3.assemblyManager;
        var assembly = assemblyManager.get(assemblyName);
        if (!assembly) {
          return [];
        }
        var refseq = self.getRefSeqTrackConf(assemblyName);
        // filter out tracks that don't match the current assembly (check all
        // assembly aliases) and display types
        return (refseq ? [refseq] : []).concat(_toConsumableArray(filterTracks(tracks, self, assemblyName)));
      },
      get assemblyNames() {
        var _a;
        return ((_a = self.view) === null || _a === void 0 ? void 0 : _a.assemblyNames) || [];
      },
      connectionTrackConfigurations: function connectionTrackConfigurations(assemblyName, connection) {
        if (!self.view) {
          return [];
        }
        // filter out tracks that don't match the current display types
        return filterTracks(connection.tracks, self, assemblyName);
      }
    };
  }).views(function (self) {
    return {
      hierarchy: function hierarchy(assemblyName) {
        var _this = this;
        var hier = generateHierarchy(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        self, self.trackConfigurations(assemblyName), self.collapsed);
        var session = getSession(self);
        var connectionInstances = session.connectionInstances;
        var _getSession4 = getSession(self),
          assemblyManager = _getSession4.assemblyManager;
        var assembly = assemblyManager.get(assemblyName);
        var conns = assembly && (connectionInstances === null || connectionInstances === void 0 ? void 0 : connectionInstances.map(function (c) {
          return {
            // @ts-ignore
            id: getSnapshot(c).configuration,
            name: getConf(c, 'name'),
            children: _this.connectionHierarchy(assemblyName, c),
            state: {
              expanded: true
            }
          };
        }).filter(function (f) {
          return f.children.length;
        })) || [];
        return {
          name: 'Root',
          id: 'Root',
          children: [{
            name: 'Tracks',
            id: 'Tracks',
            children: hier
          }].concat(_toConsumableArray(conns))
        };
      },
      connectionHierarchy: function connectionHierarchy(assemblyName, connection) {
        return generateHierarchy(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        self, self.connectionTrackConfigurations(assemblyName, connection), self.collapsed, connection.name);
      }
    };
  });
}